import { Button, Grid } from "@material-ui/core";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import { isProjectRole } from "../../redux/actions/userAction";

const SuccessPage = ({ msg, project_id, project_type, requestTypeName, partialFailure }) => {
  const toNewPersUri = `/add-new-pers/${project_id}`;
  const toEstablishedPersUri = `/add-established-pers/${project_id}`;

  return (
    <Grid
      item
      xs={12}
      style={{
        minHeight: "calc(100vh - 133px)",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        height: "100%"
      }}
    >
      {partialFailure ? (
        <WarningRoundedIcon style={{ color: "#E6A817", fontSize: "64px" }} />
      ) : (
        <CheckCircleOutlineOutlinedIcon style={{ color: "#5ACA49", fontSize: "64px" }} />
      )}
      <h2 className="mt-2">{partialFailure ? "Project Created" : "Success!"}</h2>
      <h4 className="mt-2">
        {partialFailure
          ? project_id
            ? `Project ${project_id} was created as a Draft. Files failed to upload, please use the "Add Document" button on the request page to upload your documents.`
            : `Your project was created as a Draft. Files failed to upload, please use the "Add Document" button on the request page to upload your documents.`
          : msg}
      </h4>
      <div style={{display: "flex"}}>
        {(project_type === "New Condo" && isProjectRole()) ? (
          <Button
            autoFocus
            className="mt-5"
            style={{
              color: "white",
              backgroundColor: "#1176B5",
              borderRadius: "4px",
              boxShadow:
                "0 0.4px 0.6px 0 rgba(0,0,0,0.37), 0 0.1px 0 0.4px #0A649D",
              height: "40px",
              width: "200px",
              textTransform: "capitalize",
              marginRight: "20px"
            }}
            onClick={() => {
              window.location.href = toNewPersUri;
            }}
          >
            Add PERS Request
          </Button>
        ) : (project_type === "Established Condo" && isProjectRole()) ? (
          <Button
            autoFocus
            className="mt-5"
            style={{
              color: "white",
              backgroundColor: "#1176B5",
              borderRadius: "4px",
              boxShadow:
                "0 0.4px 0.6px 0 rgba(0,0,0,0.37), 0 0.1px 0 0.4px #0A649D",
              height: "40px",
              width: "200px",
              textTransform: "capitalize",
              marginRight: "20px"
            }}
            onClick={() => {
              window.location.href = toEstablishedPersUri;
            }}
          >
            Add PERS Request
          </Button>
        ) : ("")
        }
        <Button
          autoFocus
          className="mt-5"
          style={{
            color: "white",
            backgroundColor: "#1176B5",
            borderRadius: "4px",
            boxShadow: "0 0.4px 0.6px 0 rgba(0,0,0,0.37), 0 0.1px 0 0.4px #0A649D",
            height: "40px",
            minWidth: "200px",
            textTransform: "capitalize"
          }}
          onClick={() => {
            window.location.href = (
              !project_id
              ? "/"
              : (!isProjectRole() && requestTypeName === "Lender Add Project")
              ? `/lender-project-request/${project_id}`
              : `/project/${project_id}`
            );
          }}
        >
          {!project_id
            ? "Finish"
            : (!isProjectRole() && requestTypeName === "Lender Add Project")
            ? `Go to Request Page`
            : `Go to Project Page`
          }
        </Button>
      </div>
    </Grid>
  );
};

export default SuccessPage;
